import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminLogs(filters, cursor) {
    return useQuery({
        queryKey: adminKeys.logsList(filters, cursor),
        queryFn: () => adminApi.getLogs(filters, cursor),
    });
}
export function useAdminLogDetail(logId) {
    return useQuery({
        queryKey: adminKeys.logDetail(logId),
        queryFn: () => adminApi.getLogDetail(logId),
    });
}
